export function filtrarTroncosParaOHistorico(idtrunk, PermissionRouter) {
  const hasPermissionRouter =
    Boolean(PermissionRouter) && Array.isArray(PermissionRouter);
  if (!hasPermissionRouter) return PermissionRouter;
  const filteredPermissionRouter = PermissionRouter.filter(
    (route) =>
      parseInt(idtrunk) === parseInt(route.idtrunk) || idtrunk === route.idtrunk
  );
  const hasFilteredPermissionRouter =
    Array.isArray(filteredPermissionRouter) &&
    filteredPermissionRouter.length > 0;
  if (!hasFilteredPermissionRouter) return PermissionRouter;
  return filteredPermissionRouter;
}
